import NotFound from '@/view/NotFound'

export default [
    { path: '/404', component: NotFound, meta: '404' },
    { path: '*', redirect: '/404' },
]
